import { render, staticRenderFns } from "./Nyfk.vue?vue&type=template&id=0fcfc006&scoped=true"
import script from "./Nyfk.vue?vue&type=script&lang=js"
export * from "./Nyfk.vue?vue&type=script&lang=js"
import style0 from "./Nyfk.vue?vue&type=style&index=0&id=0fcfc006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcfc006",
  null
  
)

export default component.exports